export default __webpack_public_path__ + "static/media/Slide16.6e52da1c.jpg";